import { Action, Selector, State, StateContext } from '@ngxs/store';
import { AuthStateModel } from './auth.model';
import { AuthLogin, AuthLogout, AuthRefresh } from './auth.actions';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscriber } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthResponse } from '../../shared/model/auth-response';
import { TokenUserData } from '../../shared/model/token-user-data';

import {jwtDecode} from 'jwt-decode';
import {Injectable} from '@angular/core';

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    token: null,
    user: null
  }
})
@Injectable()
export class AuthState {

  constructor(private http: HttpClient) {
  }


  @Selector()
  static token(state: AuthStateModel) {
    return state.token;
  }

  @Selector()
  static user(state: AuthStateModel) {
    return state.user;
  }


  @Action(AuthLogin)
  login(ctx: StateContext<AuthStateModel>, action: AuthLogin) {
    return new Observable<string>((subscriber: Subscriber<string>) => {
      const body = {username: action.email, password: action.password};

      this.http.post(environment.endpoints.clientBaseUrl + environment.endpoints.login, body)
        .subscribe(
          (response: AuthResponse) => {
            // Refresh token
            ctx.dispatch(new AuthRefresh(response.token));

            subscriber.next(response.token);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }

  @Action(AuthRefresh)
  refresh(ctx: StateContext<AuthStateModel>, action: AuthRefresh) {
    // Decode the new token
    const user = <TokenUserData>jwtDecode(action.token);

    ctx.patchState({
      token: action.token,
      user: user
    });
  }

  @Action(AuthLogout)
  logout(ctx: StateContext<AuthStateModel>) {
    return new Observable<Response>((subscriber: Subscriber<Response>) => {
      this.http.post(environment.endpoints.clientBaseUrl + environment.endpoints.logout, {})
        .subscribe(
          (response: Response) => {
            ctx.patchState({
              token: null,
              user: null
            });
            subscriber.next(response);
            subscriber.complete();
          },
          (error: any) => {
            subscriber.error(error);
          }
        );
    });
  }
}
